import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative bg-navy text-white overflow-hidden pt-20 pb-24 md:pt-32 md:pb-32 px-4" data-id="element-119">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-120">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-navy-light blur-[120px] opacity-50" data-id="element-121" />
        <div className="absolute top-[60%] -left-[10%] w-[40%] h-[40%] rounded-full bg-orange-dark blur-[150px] opacity-20" data-id="element-122" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-123">
        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-124">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-center md:text-left" data-id="element-125">
            <div className="inline-block bg-orange/20 text-orange-light font-bold px-4 py-1.5 rounded-full text-sm mb-6 uppercase tracking-wider" data-id="element-126">
              Para padres de niños de 8 a 15 años
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-black leading-tight mb-6" data-id="element-127">
              Convierte a tu hijo de{' '}
              <span className="text-orange" data-id="element-128">"Consumidor de Pantallas"</span> a
              "Mini-CEO" en un solo fin de semana.
            </h1>
            <p className="text-lg md:text-xl text-gray-300 font-body mb-10 leading-relaxed" data-id="element-129">
              El sistema probado para que niños de 8 a 15 años lancen su primer
              micro-negocio real en EE.UU., ganen sus primeros $20-$50 y
              aprendan el valor del dinero sin aburridas clases de teoría.
            </p>

            <CTAButton className="md:mx-0" data-id="element-130" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-131">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-navy-dark/50 border border-white/10" data-id="element-132">
              <img src="https://cdn.magicpatterns.com/uploads/8zzbDAbTK66F9qLgZLHbJV/heylloyd-image-1775583871620.png" alt="Mini-CEO Blueprint en múltiples dispositivos" className="w-full h-auto object-cover" data-id="element-133" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/40 to-transparent pointer-events-none" data-id="element-134" />
            </div>

            {/* Floating badge */}
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            repeat: Infinity,
            duration: 3,
            ease: 'easeInOut'
          }} className="absolute -bottom-6 -left-6 bg-white text-navy font-bold py-3 px-6 rounded-xl shadow-xl border border-gray-light flex items-center gap-3" data-id="element-135">
              <span className="text-3xl" data-id="element-136">🚀</span>
              <div className="text-left" data-id="element-137">
                <div className="text-sm text-gray-500 font-body font-medium" data-id="element-138">
                  Resultados en
                </div>
                <div className="text-xl font-heading leading-none" data-id="element-139">
                  48 Horas
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}